import React from 'react';
import PropTypes from 'prop-types';


import * as styleUtils from '../../../../utils/styleUtils';

import {I18nMessage} from '../../../contexts/I18n';

import styles from './FormElement.scss';
import FormFieldError from '../FormFieldError';


function FormElement(
    {
        children,
        doShowErrorAtLabel,
        doShowRequiredBeforeLabel,
        error,
        id,
        isFullWidth,
        isLeft,
        isRequired,
        label,
        labelClass,
        labelI18n
    }
) {

    const formElementClasses = styleUtils.toClasses(
        styles.formElement,
        isLeft && styles.left || null,
        isFullWidth && styles.full || null,
        'col-6'
    );

    const labelTextClass = isLeft ? 'col-7' : 'col-5';
    const childrenClass = isLeft ? 'col-5' : 'col-7';

    return (
        <div className={formElementClasses}>
            <label
                className={styleUtils.toClasses(labelClass, error && 'error' || null, 'grid-gutter-x-standard', 'row')}
                htmlFor={id}
            >

                {isLeft && (<div className={childrenClass}>{children}</div>)}

                <div className={labelTextClass}>

                    {doShowRequiredBeforeLabel && isRequired && (
                        <>
                            <I18nMessage id={'form.element.required'}/>&nbsp;
                        </>
                    )}

                    {label}
                    {labelI18n && (<I18nMessage id={labelI18n}/>)}
                    {isLeft !== true && <I18nMessage id={'form.element.label.separator'}/>}

                    {!doShowRequiredBeforeLabel && isRequired && <I18nMessage id={'form.element.required'}/>}

                    {doShowErrorAtLabel && <FormFieldError error={error}/>}

                </div>

                {!isLeft && (<div className={childrenClass}>{children}</div>)}

            </label>
        </div>
    );
}


FormElement.propTypes = {
    children: PropTypes.any,
    doShowErrorAtLabel: PropTypes.bool,
    doShowRequiredBeforeLabel: PropTypes.bool,
    error: PropTypes.object,
    id: PropTypes.string,
    isFullWidth: PropTypes.bool,
    isLeft: PropTypes.bool,
    isRequired: PropTypes.bool,
    label: PropTypes.any,
    labelClass: PropTypes.string,
    labelI18n: PropTypes.string
};

FormElement.defaultProps = {
    doShowErrorAtLabel: false,
    doShowRequiredBeforeLabel: false,
    isFullWidth: false,
    isLeft: false,
    isRequired: false
};


export default FormElement;
